import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/login.scss";
import axios from "axios";
import { Checkbox } from "@mui/material";
import { loginReducer, sidebarReducer } from "../../Redux/store";
import { AccessTockenReducer } from "../../Redux/store";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Route, Navigate ,useNavigate } from 'react-router-dom';
import LoginLogo from "../../images/Cyber security.svg"
import { InputAdornment, IconButton } from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Userlogin() {
  const navigate = useNavigate();


  const dispatch = useDispatch();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginFail, setLoginFail] = useState(false);


  const [notAuth, setNotAuth] = useState(false);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);
  const [isChecked, setIsChecked] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

  const handleSubmit = (e) => {

      e.preventDefault();

      if (!emailPattern.test(userName)) {
        setLoginFail(true);
        setNotAuth(false);
        return;
      }
    if(userName=="")
      {
         console.log("no user name")
        toast.warn('User EmailID is missing', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
      }
      if(password=="")
        {
          console.log("no password")
          toast.warn('Password is missing', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        }
    if(userName!="" && password!="")
    {

      console.log("both are there")
      login()
    }
  };
  const login = async () => {
    dispatch(sidebarReducer.apiLoad(true));
    dispatch(AccessTockenReducer.userType("platform"));
  
    try {
      const response = await axios.post(
        "/v1/auth/login",
        JSON.stringify({ te_useremail: userName, te_userpassword: password }),
        {
          headers: { "content-type": "application/json" },
        }
      );

       console.log("response",response.status)


      if (response.status === 200) {
        dispatch(sidebarReducer.apiLoad(false));
        if (
          response.data.message === "User not found" ||
          response.data.message === "Incorrect Password"
        ) {
          setLoginFail(true);
          navigate('/login');
        }
       
         else {
          if (isChecked) {
            localStorage.setItem("rememberMe", "true");
          } else {
            localStorage.removeItem("rememberMe");
            setIsChecked(false);
          }
          setLoginFail(false);
          dispatch(loginReducer.Login());
          dispatch(sidebarReducer.stringUpdate("DashBoard"));
  
          const accessTKN = response.data.data.user_details.access_token;
          const tokenExpiry =
            response.data.data.user_details.refresh_token.tokenExpiresAt;
          const loginUserId = response.data.data.user_details.te_userid;
          const user_Name = response.data.data.user_details.te_username;
  
          dispatch(loginReducer.Login_UserId(loginUserId));
          dispatch(AccessTockenReducer.accessTocken(accessTKN));
          dispatch(AccessTockenReducer.timeOut(tokenExpiry));
          dispatch(loginReducer.Login_UserName(user_Name));
  
          sessionStorage.setItem("isLogin", true);
          sessionStorage.setItem("navigate", "DashBoard");
          let localdata = response.data.data.user_details;
          sessionStorage.setItem("userdata", JSON.stringify(localdata));
          sessionStorage.setItem("access_token", accessTKN);
          sessionStorage.setItem("timeOut", tokenExpiry);
          navigate('/dashboard');
        }
      }
     

    } catch (err) {
      dispatch(sidebarReducer.apiLoad(false));
      console.error("Login error:", err.response);
      // console.log("License Expired For this User: superadmin, Please Contact your Admin")
      if(err.response){
        console.log("abcde")
        toast.error(err.response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else
      {
        console.log("xyz")
        toast.error("Connect lost", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

      }
      
    }
  };
  
  


  return (
    <>
      <div className="login-container">
    
          <div
            className="container-fluid login-background"
            style={{
              overflow: "auto"
            }}
          >
            <div className="row">
              <img
                className="Login-title"
                src={require("../../images/LoginTitle.png")}
                alt=""
              ></img>
            </div>
            <div className="row">
              <div className=" col-lg-5 text-center col-sm-12 col-one">
                <div>
                  <form onSubmit={handleSubmit}>
                    <div className="welcomeback">Welcome back!</div>
                    <div className="signup">Please enter your details</div>
                    {loginFail && (
                    <p className="p-0 m-0 text-danger">
                      Invalid Email ID or password
                    </p>
                  )}
                  {notAuth && (
                    <p className="p-0 m-0 text-danger">
                      You are not authorzied to access!
                    </p>
                  )}
                 

                    <Box
                      sx={{
                        "& > :not(style)": {
                          m: 1,
                          width: "459px",
                          marginLeft: "30px"
                        }
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <div className="label-items">Email ID </div>
                      <TextField
                        id="UserName"
                        placeholder="Email Id"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: false
                        }}
                        maxLength={"15"}
                        value={userName}
                        sx={{
                          '& .MuiOutlinedInput-root':{
                            background:"#F9F8F4",
                            border:"1px solid #334456",
                            borderRadius:"10px"
                          },
                          "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover":
                            {
                              "& > fieldset": {
                                borderColor: "#334456"
                              }
                            }
                        }}
                        InputProps={{
                          style: {
                            height: "47px",
                            color: "#171616"
                          }
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          setUserName(value);
                          setLoginFail(false);
                          setNotAuth(false);
                        }}
                      />

                      <br></br>
                      <div className="label-items">Password</div>
                      <TextField
                        placeholder="Password"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: false,
                          // sx: { color: "#5F5B5B" }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root':{
                            background:"#F9F8F4",
                            border:"1px solid #334456",
                            borderRadius:"10px"
                          },
                          "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover":
                            {
                              "& > fieldset": {
                                borderColor: "#334456", 
                                
                              }
                            }
                        }}
                        minLength="8"
                        maxLength="20"
                        value={password}
                        onChange={(e) => {
                          const { value } = e.target;
                          setPassword(value);
                          setLoginFail(false);
                          setNotAuth(false);
                        }}
                        type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                        // onChange={someChangeHandler}
                        InputProps={{
                          // <-- This is where the toggle button is added.
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                style={{ color: "#171616" }}
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                          style: {
                            height: "47px",
                            color: "#171616"
                          }
                        }}
                      />
                    </Box>
                
                      {/* <div
                        className="col-6 checkboxalign"
                        style={
                          userName !== "" && password !== ""
                            ? { opacity: "1" }
                            : { opacity: "0.5" }
                        }
                      >
                        <Checkbox
                          size="small"
                          sx={{ "& .MuiSvgIcon-root": { color: "#016895" } }}
                          checked={isChecked}
                          disabled={
                            userName !== "" && password !== "" ? false : true
                          }
                          onChange={(e) => {
                            setIsChecked(e.target.checked);
                          }}
                        />
                        <label>Remember for 30 days</label>
                      </div> */}
                      <div className="col-6 forgetpasswordalign">
                        <div
                          className="forgotpassword"
                          onClick={() => {
                            dispatch(loginReducer.Forget_password(true));
                            navigate('/ForgotPassword');
                          }}
                        >
                          <button className="forgot-button">Forgot Password</button>
                        </div>
                      </div>
                  
                    <div className="button-align"> <button className="signupbtn" type="submit">
                      Sign in
                    </button></div>
                   
                    <br></br>
                  </form>
                </div>
              </div>
              <div className="col-lg-1 col-md-12 col-sm-12"></div>
              <div className="col-lg-6 col-md-12 col-sm-12 col-two">
                <img
                  style={{ width: "90%",padding:"20px"}}
                  src={LoginLogo}
                  alt="TATA Elxsi"
                ></img>
              </div>
            </div>
          </div>

          <div className="backdrop">
            <Backdrop
              sx={{
                color: "var(--themes-color)",
                zIndex: (theme) => theme.zIndex.drawer + 1
              }}
              open={apiLoad}
              //onClick={handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        {/* </UnauthenticatedTemplate> */}
      </div>
    </>
  );
}
export default Userlogin;
